import { supabase } from '@/lib/supabase'
import type { Customer } from '@/types/domain'

export const customersRepo = {
  async findAll(): Promise<Customer[]> {
    const { data, error } = await supabase
      .from('customers')
      .select('*, client:client_id(name)')
      .order('created_at', { ascending: false })

    if (error) throw error
    return (data || []) as any
  },

  async findByClient(clientId: string): Promise<Customer[]> {
    const { data, error } = await supabase
      .from('customers')
      .select('*')
      .eq('client_id', clientId)
      .order('name', { ascending: true })

    if (error) throw error
    return (data || []) as Customer[]
  },

  async findById(id: string): Promise<Customer | null> {
    const { data, error } = await supabase
      .from('customers')
      .select('*')
      .eq('id', id)
      .single()

    if (error) throw error
    return data as Customer
  },

  async create(customer: any): Promise<Customer> {
    const { data, error } = await supabase
      .from('customers')
      .insert(customer as any)
      .select()
      .single()

    if (error) throw error
    return data as Customer
  },

  async update(id: string, updates: any): Promise<Customer> {
    const { data, error } = await supabase
      .from('customers')
      .update(updates as never)
      .eq('id', id)
      .select()
      .single()

    if (error) throw error
    return data as Customer
  },

  async delete(id: string): Promise<void> {
    console.log('Attempting to delete customer:', id)

    const { error } = await supabase
      .from('customers')
      .delete()
      .eq('id', id)

    if (error) {
      console.error('Delete customer error details:', {
        message: error.message,
        details: error.details,
        hint: error.hint,
        code: error.code,
      })
      throw new Error(`Failed to delete customer: ${error.message}${error.hint ? ` (${error.hint})` : ''}`)
    }

    console.log('Customer deleted successfully')
  },
}
